/**
 * Checks if the given pathname is a CRM detail page (client or company).
 */
export const isOnCrmPage = (pathname: string): boolean => {
  return (
    pathname.startsWith('/clients/users/details/') ||
    /^\/companies\/[^/]+/.test(pathname)
  );
};
